import { render, staticRenderFns } from "./PLkiapiao.vue?vue&type=template&id=137eb9a0&scoped=true&"
import script from "./PLkiapiao.vue?vue&type=script&lang=js&"
export * from "./PLkiapiao.vue?vue&type=script&lang=js&"
import style0 from "./PLkiapiao.vue?vue&type=style&index=0&id=137eb9a0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137eb9a0",
  null
  
)

export default component.exports